export class StorageKey {
  static CurrentDailyCallId = 'CurrentDailyCallId';
  static CurrentCallId = 'CurrentCallId';
}
